import React, {FormEvent, useContext, useState} from "react";
import "./CommentForm.css";
import {UserContext} from "../contexts/UserContext";
import { createComment } from "../services/comments";
import { RESTComment } from "../services/types";
import {useAuthenticatedAction} from "../hooks/useAuthenticatedAction";
import Button from "./Button";
import AutoResizeTextarea from "./AutoResizeTextarea";

interface CommentFormProps {
    postId: number,
    onCommentCreated: (comment:RESTComment) => void
}

const CommentForm : React.FC<CommentFormProps> = ({postId, onCommentCreated}) => {
    const [content, setContent] = useState("");
    const {currentUser} = useContext(UserContext);
    const { execute: submitComment, loading: sending, error } = useAuthenticatedAction<RESTComment, [RESTComment]>();

    const onSubmit = async (event:FormEvent) => {
        event.preventDefault();
        
        const restComment : RESTComment = {
            content: content,
            post: postId
        }
        
        const result = await submitComment(createComment, restComment);
        if (result) {
            onCommentCreated(result);
            setContent("");
        }
        return false;
    }

    if(currentUser === null){
        return null;
    }

    return (
        <form id={"comment-form"} className={"CommentForm"} onSubmit={onSubmit}>
            {error && (
                <div className="CommentForm-error">
                    {error}
                </div>
            )}
            <AutoResizeTextarea
                id="comment-content"
                name="content"
                placeholder={"Laisser un commentaire"} 
                autoComplete={"off"} 
                disabled={sending}
                value={content} 
                onChange={(e) => setContent(e.target.value)}
                minRows={1}
                maxRows={6}
                rows={1}
            />
            <Button type="submit" variant="primary" size="small" disabled={content === ""} loading={sending}>
                Envoyer
            </Button>
        </form>
    )
}

export default CommentForm;